module.exports = __webpack_public_path__ + "img/de.182b61be.jpg";